import { Component, OnInit, Input } from '@angular/core';
import { InvoiceService } from '../../invoices/invoice.service';
import { DialogService } from '../../_services';
import { first, last } from 'rxjs/operators';
import { StringConstants } from '../../_constants/stringConstants';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'neft-statement',
  templateUrl: './neft-statement.component.html',
})
export class NeftStatementComponent implements OnInit {

  // private pleaseWait: string = this.translate.instant('MESSAGES.PLEASE_WAIT');

  @Input() balance: any = {};
  loading = false;
  neftStatementList;
  neftBalance;

  constructor(
    private invoiceService: InvoiceService,
    private dialogService: DialogService,
    private modal:ModalController,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getNeftStatementList();
    this.neftBalance = this.balance;
  }

  getNeftStatementList() {
    this.setAppBusy();
    this.invoiceService.getNeftStatement().pipe(first()).subscribe(data => {
      this.setAppIdle();
      this.neftStatementList = data;
    }, (err) => {
      this.setAppIdle();
      //
      console.log(err);
      setTimeout(() => {
        this.close();
      }, 100);
    });
  }



  setAppBusy() {
    this.loading = true;
    this.dialogService.showWaitMessage(this.translate.instant('MESSAGES.PLEASE_WAIT'));
  }
  setAppIdle() {
    this.loading = false;
    this.dialogService.hideWaitMessage();
  }
  close() {
    this.modal.dismiss();
  }




}
